import React from 'react'

import { BaseView } from '@/components/base'
import { DepositTypeItem } from '../DepositTypeItem'
import { useDepositTypes } from '../../hooks/useDepositTypes'

interface WalletData {
  code?: string
  // TODO: добавить другие поля кошелька
}

interface DepositTypeListProps {
  isBuy?: boolean
  walletData?: WalletData
}

export const DepositTypeList: React.FC<DepositTypeListProps> = ({
  isBuy,
  walletData,
}) => {
  const depositTypes = useDepositTypes({ isBuy, walletData })
  const availableDepositTypes = depositTypes.filter((deposit) => {
    return deposit.isAvailable
  })

  return (
    <BaseView gap={12}>
      {availableDepositTypes.map((depositType) => (
        <DepositTypeItem key={depositType.type} {...depositType} />
      ))}
    </BaseView>
  )
}
